import type { CSSProperties } from 'react';

/**
 * A plectrum: the Picks icon. Drawn inline rather than taken from the icon
 * set, which has no pick, and shaped to read at 14 px in a chip.
 */
export function PickIcon({
  size = 20,
  strokeWidth = 2.5,
  filled = false,
  className,
  style,
}: {
  size?: number;
  strokeWidth?: number;
  filled?: boolean;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
      style={style}
    >
      <path d="M12 21.5c-3.6-2.3-7.5-7.6-7.5-12.3A7.5 7.5 0 0 1 12 2a7.5 7.5 0 0 1 7.5 7.2c0 4.7-3.9 10-7.5 12.3z" />
    </svg>
  );
}
